.root {
  .label {
    color: var(--mantine-color-primary-7);
    margin-bottom: 6px;
    font-size: 1rem;
    font-weight: 600;
  }

  &[data-variant='filled'] {
    .input {
      background-color: var(--mantine-color-primary-0) !important;
    }
  }

  &[data-variant='unstyled'] {
    .input {
      background-color: transparent !important;
    }
  }
}

.wrapper {
  height: 3rem;
}

.input {
  height: 100% !important;
  background-color: var(--mantine-color-otherWhite-1) !important;

  :global(.mantine-InputPlaceholder-placeholder) {
    color: var(--mantine-color-tertiary-7);
    font-size: 0.875rem;
  }
}

.dropdown {
  background-color: var(--mantine-color-otherWhite-1) !important;
  border-radius: var(--mantine-radius-default);
  border: none !important;
  box-shadow: var(--mantine-shadow-sm) !important;
}

.calendarHeaderLevel {
  @media (hover: hover) {
    &:hover {
      background: transparent !important;
      border: 1px solid var(--mantine-color-secondary-7);
    }
  }
}

.calendarHeaderControl {
  border: 1px solid var(--mantine-color-secondary-7);

  @media (hover: hover) {
    &:hover {
      background: transparent !important;
      border: 1px solid var(--mantine-color-secondary-7);
    }
  }
}

.monthsListControl {
  @media (hover: hover) {
    &:hover {
      background: transparent !important;
      border: 1px solid var(--mantine-color-secondary-7);
    }
  }
}

.yearsListControl {
  @media (hover: hover) {
    &:hover {
      background: transparent !important;
      border: 1px solid var(--mantine-color-secondary-7);
    }
  }
}

.day {
  color: var(--mantine-color-textInDark-0);

  @media (hover: hover) {
    &:hover {
      border: 1px solid var(--mantine-color-secondary-7);
      color: var(--mantine-color-textInDark-0);

      &[data-selected] {
        background-color: var(--mantine-color-secondary-7);
      }
    }
  }

  &[data-selected] {
    background-color: var(--mantine-color-secondary-7);
  }

  &[data-in-range] {
    background-color: var(--mantine-color-secondary-0);
    color: var(--mantine-color-textInLight-0);
    border-radius: 0.375rem;

    @media (hover: hover) {
      &:hover {
        color: var(--mantine-color-textInDark-0);
        background: transparent;
      }
    }
  }

  &[data-first-in-range] {
    border-radius: 0.375rem;
    color: var(--mantine-color-textInDark-0);
    background-color: var(--mantine-color-secondary-7);

    @media (hover: hover) {
      &:hover {
        background-color: var(--mantine-color-secondary-7);
      }
    }
  }

  &[data-last-in-range] {
    border-radius: 0.375rem;
    color: var(--mantine-color-textInDark-0);
    background-color: var(--mantine-color-secondary-7);

    @media (hover: hover) {
      &:hover {
        background-color: var(--mantine-color-secondary-7);
      }
    }
  }

  &[data-size='xs'] {
    width: var(--mantine-calendar-day-size-xs);
    height: var(--mantine-calendar-day-size-xs);
  }

  &[data-size='sm'] {
    width: var(--mantine-calendar-day-size-sm);
    height: var(--mantine-calendar-day-size-sm);
  }

  &[data-size='md'] {
    width: var(--mantine-calendar-day-size-md);
    height: var(--mantine-calendar-day-size-md);
  }

  &[data-size='lg'] {
    width: var(--mantine-calendar-day-size-lg);
    height: var(--mantine-calendar-day-size-lg);
  }

  &[data-size='xl'] {
    width: var(--mantine-calendar-day-size-xl);
    height: var(--mantine-calendar-day-size-xl);
  }
}
